import React from 'react';
import { useCenturionHomepageContent } from '@/hooks/cdaasHooks/cdaasHelperHooks';
import { CenturionNetworkVideo } from './CenturionNetworkVideo';
import { CenturionIntroSection } from './CenturionIntroSection';
import { CenturionCarrouselSection } from './CenturionCarrouselSection';
import { CenturionNetworkLounges } from './CenturionNetworkLounges';
import { CenturionNetworkFAQs } from './CenturionNetworkFAQs';
import { CenturionHomepage } from '../CulinaryCollective/interface';
import Quote from '../common/Quote';

const CenturionNetworkPage = () => {
  const centurionHomepageContent: CenturionHomepage =
    useCenturionHomepageContent();

  const {
    title,
    pageIntro,
    threeUpBlocks: networkHighlights,
    quote,
  } = centurionHomepageContent;

  return (
    // <div className="tw-mx-auto tw-max-w-screen-x2l md_tw-px-0 md_tw-px-6 lg_tw-px-8 xl_tw-px-10">
    <div className="tw-flex tw-flex-col">
      <CenturionNetworkVideo />
      <div className="tw-mx-auto tw-flex tw-flex-col tw-p-3 tw-px-4 md_tw-px-6 lg_tw-max-w-360 lg_tw-px-8 xl_tw-px-10">
        <CenturionIntroSection
          title={title}
          intro={pageIntro}
          networkHighlights={networkHighlights}
        />
        <hr className="tw-my-10" />
        {quote && <Quote text={quote} />}
      </div>
      <div>
        <div className="tw-col-span-10 tw-col-start-2 tw-grid tw-grid-cols-1">
          Carousel Title
        </div>
        <CenturionCarrouselSection />
      </div>
      <div className="tw-col-span-10 tw-col-start-2 tw-grid tw-grid-cols-1">
        <CenturionNetworkLounges />
      </div>
      <div className="tw-col-span-10 tw-col-start-2 tw-grid tw-grid-cols-1">
        <CenturionNetworkFAQs />
      </div>
    </div>
  );
};

export default CenturionNetworkPage;
